import React, { Suspense } from 'react'

const PayMainBase = React.lazy(() => import('./PayMain'))

export const PayMainPage = () => (
  <Suspense fallback={null}>
    <PayMainBase />
  </Suspense>
)
